interface LanguageData {
    languageId: number
    name: string
    flag: string | null
}

function getLanguageDataById(id?: string | number | null): LanguageData | undefined {
    if (id === undefined || id === null) {
        return undefined
    }
    const languagesData: Record<number, LanguageData> = {
        1: {
            languageId: 1,
            name: 'Afrikaans',
            flag: '/assets/img/flags_rounded/Rounded=South Africa (ZA).svg',
        },
        2: {
            languageId: 2,
            name: 'Arabic',
            flag: '/assets/img/flags_rounded/Rounded=Arabic.svg',
        },
        3: {
            languageId: 3,
            name: 'Bahasa Indonesia',
            flag: '/assets/img/flags_rounded/Rounded=Indonesia (ID).svg',
        },
        4: {
            languageId: 4,
            name: 'Azeri ',
            flag: '/assets/img/flags_rounded/Rounded=Azerbaijan (AZ).svg',
        },
        5: {
            languageId: 5,
            name: 'Belarusian',
            flag: '/assets/img/flags_rounded/Rounded=Belarus (BY).svg',
        },
        6: {
            languageId: 6,
            name: 'Bulgarian',
            flag: '/assets/img/flags_rounded/Rounded=Bulgaria (BG).svg',
        },
        7: {
            languageId: 7,
            name: 'Bosnian',
            flag: '/assets/img/flags_rounded/Rounded=Bosnia and Herzegovina (BA).svg',
        },
        8: {
            languageId: 8,
            name: 'Catalan',
            flag: '/assets/img/flags_rounded/Rounded=Catalonia (ES-CT).svg',
        },
        9: {
            languageId: 9,
            name: 'Czech',
            flag: '/assets/img/flags_rounded/Rounded=Czech Republic (CZ).svg',
        },
        10: {
            languageId: 10,
            name: 'Welsh',
            flag: '/assets/img/flags_rounded/Rounded=Wales (GB-WLS).svg',
        },
        11: {
            languageId: 11,
            name: 'Danish',
            flag: '/assets/img/flags_rounded/Rounded=Denmark (DK).svg',
        },
        12: {
            languageId: 12,
            name: 'German',
            flag: '/assets/img/flags_rounded/Rounded=Germany (DE).svg',
        },
        13: {
            languageId: 13,
            name: 'Divehi',
            flag: '/assets/img/flags_rounded/Rounded=Maldives (MV).svg',
        },
        14: {
            languageId: 14,
            name: 'Greek',
            flag: '/assets/img/flags_rounded/Rounded=Greece (GR).svg',
        },
        15: {
            languageId: 15,
            name: 'English',
            flag: '/assets/img/flags_rounded/Rounded=United Kingdom (GB).svg',
        },
        16: {
            languageId: 16,
            name: 'Esperanto',
            flag: '/assets/img/flags_rounded/Rounded=Esperanto.svg',
        },
        17: {
            languageId: 17,
            name: 'Spanish',
            flag: '/assets/img/flags_rounded/Rounded=Spain (ES).svg',
        },
        18: {
            languageId: 18,
            name: 'Estonian',
            flag: '/assets/img/flags_rounded/Rounded=Estonia (EE).svg',
        },
        19: {
            languageId: 19,
            name: 'Basque',
            flag: '/assets/img/flags_rounded/Rounded=Basque.svg',
        },
        20: {
            languageId: 20,
            name: 'Farsi',
            flag: '/assets/img/flags_rounded/Rounded=Iran (Islamic Republic of) (IR).svg',
        },
        21: {
            languageId: 21,
            name: 'Finnish',
            flag: '/assets/img/flags_rounded/Rounded=Finland (FI).svg',
        },
        22: {
            languageId: 22,
            name: 'Faroese',
            flag: '/assets/img/flags_rounded/Rounded=Faroe Islands (FO).svg',
        },
        23: {
            languageId: 23,
            name: 'French',
            flag: '/assets/img/flags_rounded/Rounded=France (FR).svg',
        },
        24: {
            languageId: 24,
            name: 'Galician',
            flag: '/assets/img/flags_rounded/Rounded=Galicia (ES-GA).svg',
        },
        25: {
            languageId: 25,
            name: 'Gujarati',
            flag: '/assets/img/flags_rounded/Rounded=India (IN).svg',
        },
        26: {
            languageId: 26,
            name: 'Hebrew',
            flag: '/assets/img/flags_rounded/Rounded=Israel (IL).svg',
        },
        27: {
            languageId: 27,
            name: 'Hindi',
            flag: '/assets/img/flags_rounded/Rounded=India (IN).svg',
        },
        28: {
            languageId: 28,
            name: 'Croatian',
            flag: '/assets/img/flags_rounded/Rounded=Croatia (HR).svg',
        },
        29: {
            languageId: 29,
            name: 'Hungarian',
            flag: '/assets/img/flags_rounded/Rounded=Hungary (HU).svg',
        },
        30: {
            languageId: 30,
            name: 'Armenian',
            flag: '/assets/img/flags_rounded/Rounded=Armenia (AM).svg',
        },
        31: {
            languageId: 31,
            name: 'Indonesian',
            flag: '/assets/img/flags_rounded/Rounded=Indonesia (ID).svg',
        },
        32: {
            languageId: 32,
            name: 'Icelandic',
            flag: '/assets/img/flags_rounded/Rounded=Iceland (IS).svg',
        },
        33: {
            languageId: 33,
            name: 'Italian',
            flag: '/assets/img/flags_rounded/Rounded=Italy (IT).svg',
        },
        34: {
            languageId: 34,
            name: 'Japanese',
            flag: '/assets/img/flags_rounded/Rounded=Japan (JP).svg',
        },
        35: {
            languageId: 35,
            name: 'Georgian',
            flag: '/assets/img/flags_rounded/Rounded=Georgia (GE).svg',
        },
        36: {
            languageId: 36,
            name: 'Kazakh',
            flag: '/assets/img/flags_rounded/Rounded=Kazakhstan (KZ).svg',
        },
        37: {
            languageId: 37,
            name: 'Kannada',
            flag: '/assets/img/flags_rounded/Rounded=India (IN).svg',
        },
        38: {
            languageId: 38,
            name: 'Korean',
            flag: '/assets/img/flags_rounded/Rounded=South Korea (KR).svg',
        },
        39: {
            languageId: 39,
            name: 'Konkani',
            flag: '/assets/img/flags_rounded/Rounded=India (IN).svg',
        },
        40: {
            languageId: 40,
            name: 'Kyrgyz',
            flag: '/assets/img/flags_rounded/Rounded=Kyrgyzstan (KG).svg',
        },
        41: {
            languageId: 41,
            name: 'Lithuanian',
            flag: '/assets/img/flags_rounded/Rounded=Lithuania (LT).svg',
        },
        42: {
            languageId: 42,
            name: 'Latvian',
            flag: '/assets/img/flags_rounded/Rounded=Latvia (LV).svg',
        },
        43: {
            languageId: 43,
            name: 'Maori',
            flag: '/assets/img/flags_rounded/Rounded=Maori.svg',
        },
        44: {
            languageId: 44,
            name: 'FYRO Macedonian',
            flag: '/assets/img/flags_rounded/Rounded=North Macedonia (MK).svg',
        },
        45: {
            languageId: 45,
            name: 'Mongolian',
            flag: '/assets/img/flags_rounded/Rounded=Mongolia (MN).svg',
        },
        46: {
            languageId: 46,
            name: 'Marathi',
            flag: '/assets/img/flags_rounded/Rounded=India (IN).svg',
        },
        47: {
            languageId: 47,
            name: 'Malay',
            flag: '/assets/img/flags_rounded/Rounded=Malaysia (MY).svg',
        },
        48: {
            languageId: 48,
            name: 'Maltese',
            flag: '/assets/img/flags_rounded/Rounded=Malta (MT).svg',
        },
        49: {
            languageId: 49,
            name: 'Norwegian',
            flag: '/assets/img/flags_rounded/Rounded=Norway (NO).svg',
        },
        50: {
            languageId: 50,
            name: 'Slovenian',
            flag: '/assets/img/flags_rounded/Rounded=Slovenia (SI).svg',
        },
        51: {
            languageId: 51,
            name: 'Dutch',
            flag: '/assets/img/flags_rounded/Rounded=Netherlands (NL).svg',
        },
        52: {
            languageId: 52,
            name: 'Northern Sotho',
            flag: '/assets/img/flags_rounded/Rounded=South Africa (ZA).svg',
        },
        53: {
            languageId: 53,
            name: 'Punjabi',
            flag: '/assets/img/flags_rounded/Rounded=India (IN).svg',
        },
        54: {
            languageId: 54,
            name: 'Polish',
            flag: '/assets/img/flags_rounded/Rounded=Poland (PL).svg',
        },
        55: {
            languageId: 55,
            name: 'Pashto',
            flag: '/assets/img/flags_rounded/Rounded=Afghanistan (AF).svg',
        },
        56: {
            languageId: 56,
            name: 'Portuguese',
            flag: '/assets/img/flags_rounded/Rounded=Portugal (PT).svg',
        },
        57: {
            languageId: 57,
            name: 'Quechua',
            flag: '/assets/img/flags_rounded/Rounded=Quechuas.svg',
        },
        58: {
            languageId: 58,
            name: 'Romanian',
            flag: '/assets/img/flags_rounded/Rounded=Romania (RO).svg',
        },
        59: {
            languageId: 59,
            name: 'Russian',
            flag: '/assets/img/flags_rounded/Rounded=Russia (RU).svg',
        },
        60: {
            languageId: 60,
            name: 'Sanskrit',
            flag: '/assets/img/flags_rounded/Rounded=India (IN).svg',
        },
        61: {
            languageId: 61,
            name: 'Sami',
            flag: '/assets/img/flags_rounded/Rounded=Sami.svg',
        },
        62: {
            languageId: 62,
            name: 'Slovak',
            flag: '/assets/img/flags_rounded/Rounded=Slovakia (SK).svg',
        },
        63: {
            languageId: 63,
            name: 'Albanian',
            flag: '/assets/img/flags_rounded/Rounded=Albania (AL).svg',
        },
        64: {
            languageId: 64,
            name: 'Serbian',
            flag: '/assets/img/flags_rounded/Rounded=Serbia (RS).svg',
        },
        65: {
            languageId: 65,
            name: 'Swedish',
            flag: '/assets/img/flags_rounded/Rounded=Sweden (SE).svg',
        },
        66: {
            languageId: 66,
            name: 'Swahili',
            flag: '/assets/img/flags_rounded/Rounded=Kenya (KE).svg',
        },
        67: {
            languageId: 67,
            name: 'Syriac',
            flag: '/assets/img/flags_rounded/Rounded=Syrian Arab Republic (SY).svg',
        },
        68: {
            languageId: 68,
            name: 'Tamil',
            flag: '/assets/img/flags_rounded/Rounded=India (IN).svg',
        },
        69: {
            languageId: 69,
            name: 'Telugu',
            flag: '/assets/img/flags_rounded/Rounded=India (IN).svg',
        },
        70: {
            languageId: 70,
            name: 'Thai',
            flag: '/assets/img/flags_rounded/Rounded=Thailand (TH).svg',
        },
        71: {
            languageId: 71,
            name: 'Tagalog',
            flag: '/assets/img/flags_rounded/Rounded=Philippines (PH).svg',
        },
        72: {
            languageId: 72,
            name: 'Tswana',
            flag: '/assets/img/flags_rounded/Rounded=South Africa (ZA).svg',
        },
        73: {
            languageId: 73,
            name: 'Turkish',
            flag: '/assets/img/flags_rounded/Rounded=Turkey (TR).svg',
        },
        74: {
            languageId: 74,
            name: 'Tatar',
            flag: '/assets/img/flags_rounded/Rounded=Tatar.svg',
        },
        75: {
            languageId: 75,
            name: 'Tsonga',
            flag: '/assets/img/flags_rounded/Rounded=South Africa (ZA).svg',
        },
        76: {
            languageId: 76,
            name: 'Ukrainian',
            flag: '/assets/img/flags_rounded/Rounded=Ukraine (UA).svg',
        },
        77: {
            languageId: 77,
            name: 'Urdu',
            flag: '/assets/img/flags_rounded/Rounded=India (IN).svg',
        },
        78: {
            languageId: 78,
            name: 'Uzbek',
            flag: '/assets/img/flags_rounded/Rounded=Uzbekistan (UZ).svg',
        },
        79: {
            languageId: 79,
            name: 'Vietnamese',
            flag: '/assets/img/flags_rounded/Rounded=Vietnam (VN).svg',
        },
        80: {
            languageId: 80,
            name: 'Xhosa',
            flag: '/assets/img/flags_rounded/Rounded=South Africa (ZA).svg',
        },
        81: {
            languageId: 81,
            name: 'Chinese',
            flag: '/assets/img/flags_rounded/Rounded=China (CN).svg',
        },
        82: {
            languageId: 82,
            name: 'Zulu',
            flag: '/assets/img/flags_rounded/Rounded=South Africa (ZA).svg',
        },
        85: {
            languageId: 85,
            name: 'Somali',
            flag: '/assets/img/flags_rounded/Rounded=Somalia (SO).svg',
        },
        86: {
            languageId: 86,
            name: 'Norsk tegnspråk',
            flag: '/assets/img/flags_rounded/Rounded=Norway (NO).svg',
        },
        87: {
            languageId: 87,
            name: 'Philippine',
            flag: '/assets/img/flags_rounded/Rounded=Philippines (PH).svg',
        },
        88: {
            languageId: 88,
            name: 'Kurdish',
            flag: '/assets/img/flags_rounded/Rounded=Kurdish.svg',
        },
        89: {
            languageId: 89,
            name: 'Latin',
            flag: '/assets/img/flags_rounded/Rounded=Latin.svg',
        },
        90: {
            languageId: 90,
            name: 'Bengali',
            flag: '/assets/img/flags_rounded/Rounded=Bangladesh (BD).svg',
        },
        91: {
            languageId: 91,
            name: 'Amharic',
            flag: '/assets/img/flags_rounded/Rounded=Ethiopia (ET).svg',
        },
        92: {
            languageId: 92,
            name: 'Dari',
            flag: '/assets/img/flags_rounded/Rounded=Afghanistan (AF).svg',
        },
        93: {
            languageId: 93,
            name: 'Nepali',
            flag: '/assets/img/flags_rounded/Rounded=Nepal (NP).svg',
        },
        94: {
            languageId: 94,
            name: 'Kirundi',
            flag: '/assets/img/flags_rounded/Rounded=Burundi (BI).svg',
        },
        95: {
            languageId: 95,
            name: 'Chechen',
            flag: '/assets/img/flags_rounded/Rounded=Chehen.svg',
        },
        96: {
            languageId: 96,
            name: 'Burmese',
            flag: '/assets/img/flags_rounded/Rounded=Myanmar (MM).svg',
        },
        97: {
            languageId: 97,
            name: 'Tigrinya',
            flag: '/assets/img/flags_rounded/Rounded=Ethiopia (ET).svg',
        },
        98: {
            languageId: 98,
            name: 'Greenlandic',
            flag: '/assets/img/flags_rounded/Rounded=Greenland (GL).svg',
        },
        99: {
            languageId: 99,
            name: 'Persian',
            flag: null,
        },
    }

    return languagesData[Number(id)] || undefined
}

export default getLanguageDataById
